import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    // Table,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf";

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { useReactToPrint } from "react-to-print";
import { usePostRequest } from '../../hooks/usePostRequest'
import TenantSignature from "../../Assets/Images/tenant_signature.png"
import { formatAmount, formatDate, refreshPage, extractDateTime } from '../../Utils/Common';
import { PreviewTable } from '../../Components/PreviewTable';

const DebitSOA = () => {
    const navigate = useNavigate()
    const currentDate = new Date();
    const { id, type } = useParams();
    const [soaData, setSoaData] = useState([])
    const [totalRefundable, setTotalRefundable] = useState(0)
    const [totalBilling, setTotalBilling] = useState(0)
    const [remaining, setRemaining] = useState(0)
    const [tenantData, setTenantData] = useState([])
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const { callPost, loading } = usePostRequest(()=>{
        refreshPage()
    });

    const handleSendEmail = async (ref) => {
        if (ref) {
            const element = document.getElementById(ref);
    
            html2canvas(element, { scale: 2 }).then(async (canvas) => {
                const scale = 0.7; // Set the desired scale (70%)
    
                // Create a new canvas with scaled dimensions
                const scaledCanvas = document.createElement('canvas');
                const context = scaledCanvas.getContext('2d');
                scaledCanvas.width = canvas.width * scale;
                scaledCanvas.height = canvas.height * scale;
    
                // Draw the original canvas onto the scaled canvas
                context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
                // Convert the scaled canvas to an image
                const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = scaledCanvas.width;
                const imgHeight = scaledCanvas.height;
    
                // Calculate the ratio needed to fit the image within the PDF dimensions
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
                // Calculate the new width and height of the image
                const newWidth = imgWidth * ratio;
                const newHeight = imgHeight * ratio;
    
                // Center the image in the PDF
                const imgX = (pdfWidth - newWidth) / 2;
                const imgY = 0;
    
                // Add the image to the PDF
                pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
                pdf.save(`${soaData?.account_name}_Debit_Soa_${extractDateTime(currentDate)}.pdf`);
    
                // Convert the pdf file from Blob to File obj (needed for upload API)
                const blobPdf = pdf.output('blob');
                const formPdf = new File([blobPdf], `${soaData?.account_name}_Debit_Soa_${extractDateTime(currentDate)}.pdf`, {
                    type: blobPdf.type,
                });
    
                const finalValues = Object.entries({ tenant_id: id, attachment: formPdf, filename: `${soaData?.account_name}_Debit_Soa_${extractDateTime(currentDate)}.pdf` }).map(([key, value]) => ({
                    key,
                    value,
                }));
    
                callPost('emails/send_soa', finalValues, true);
            });
        }
    };
    const dataSource = [];

    if (soaData?.advance_rental) {
        dataSource.push({
            key: "advance_rental",
            description: "Advance Rental",
            amount: soaData.advance_rental,
        });
    }
    
    if (soaData?.security_deposit) {
        dataSource.push({
            key: "security_deposit",
            description: "Security Deposits",
            amount: soaData.security_deposit,
        });
    }
    
    if (soaData?.construction_bond) {
        dataSource.push({
            key: "construction_bond",
            description: "Construction Bonds",
            amount: soaData.construction_bond,
        });
    }
      
    const columns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center'
        },
        {
            title: 'Rate',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        }
    ];

    const columns2 = [
        {
            title: 'Billing No.',
            dataIndex: 'billing_id',
            key: 'billing_id',
            align: 'center'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center',
        },
        {
            title: 'Grand Total',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        },
        {
            title: 'Paid Amount',
            dataIndex: 'paid_amount',
            key: 'paid_amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            align: 'right',
            render: (amount) => formatAmount(amount)
        }
    ];
    async function fetchSOAData  () {
        // setIsLoading(true)
        var API = type === "move-out" ? "tenants/print_moveout_soa" : "tenants/print_debit_soa"
        const response = await UseGetRequest(API, {tenant_id: id, rental_unit_id: tenantData?.rental_unit_id});
        if (response?.data) {
          setSoaData(response?.data?.data);
          setRemaining(response?.data?.data?.total)
          if(type === "move-out"){
            setTotalRefundable(response?.data?.total_refundables)
            setTotalBilling(response?.data?.total_billing_amount)
            setRemaining(response?.data?.remaining)
          }
        } else {
          setSoaData([])
        }
        // setIsLoading(false);
    }
    async function fetchTenant  () {
        // setIsLoading(true)        
        const response = await UseGetRequest('tenants/get', {tenant_id: id});
        if (response?.data) {
          setTenantData(response?.data?.data[0]);
        } else {
          setTenantData([])
        }
        // setIsLoading(false);
    }
    useEffect(() => {
       if(tenantData.length !== 0){
        fetchSOAData();
       }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [tenantData]);
    useEffect(() => {
        fetchTenant();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'property'}/>
            <Layout className='content-container content-container-print overflow-y'>
                <Row className='m-4 paper-view'>
                    <Col className='email-pad print-content' id="preview" ref={componentRef}>
                        <Row className='mb-5'>
                            <Col span={24} align="center">
                                <Image
                                    width={'auto'}
                                    height="90%"
                                    src={HeaderImage}
                                    alt="login-image"
                                    preview={false}
                                />
                            </Col>
                        </Row>
                        <Row className='center mb-2'>
                            <Col className='divider-text'>
                                STATEMENT OF ACCOUNT
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        Account Name :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.account_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={9} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        SOA No:
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {id}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        Property Name :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.property_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={9} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        Rental Unit :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.rental_unit_name}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        Business Address :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.address}
                                    </div>
                                </Space>
                            </Col>
                            {
                                type === "move-in" && (
                                    <Col span={9} align="left">
                                        <Space className='text-print'>
                                            <div className='text-sm'>
                                                Statement Date :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {soaData?.statement_date && formatDate(soaData?.statement_date)}
                                            </div>
                                        </Space>
                                    </Col>
                                )
                            }
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space className='text-print'>
                                    <div className='text-sm'>
                                        Contract Period :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {(soaData?.contract_sign_date && soaData?.contract_end_date) && formatDate(soaData?.contract_sign_date) + " - " + formatDate(soaData?.contract_end_date)}
                                    </div>
                                </Space>
                            </Col>
                            {
                                soaData?.tin && (
                                    <Col span={9} align="left">
                                        <Space className='text-print'>
                                            <div className='text-sm'>
                                                TIN :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {soaData?.tin}
                                            </div>
                                        </Space>
                                    </Col>
                                )
                            }
                        </Row>
                        {
                            type === "move-out" && (
                                <Row className='mb-2'>
                                    <Col span={15} align="left">
                                        <Space className='text-print'>
                                            <div className='text-sm'>
                                                Move Out Date:
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {(soaData?.move_out_date) && formatDate(soaData?.move_out_date)}
                                            </div>
                                        </Space>
                                    </Col>
                                    {
                                        soaData?.move_out_remarks && (
                                            <Col span={9} align="left">
                                                <Space className='text-print'>
                                                    <div className='text-sm'>
                                                        Remarks :
                                                    </div>
                                                    <div className='bold-text text-sm'>
                                                        {soaData?.move_out_remarks}
                                                    </div>
                                                </Space>
                                            </Col>
                                        )
                                    }
                                    {/* <Col span={5}>
                                        <Row>
                                            
                                        </Row>
                                    </Col> */}
                                </Row>
                            )
                        }
                        {
                            type === "move-in" ? (
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                        {/* <Table
                                            dataSource={dataSource}
                                            columns={columns}
                                            rowKey="id"
                                            pagination={false}
                                        /> */}
                                        <PreviewTable
                                            dataSource={dataSource}
                                            columns={columns}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <>
                                    {
                                        soaData?.refundables && (
                                            <>
                                                <Row gutter={[16, 16]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                                        Refundables
                                                    </Col>
                                                </Row>
                                                <Row gutter={[16, 16]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                                        {/* <Table
                                                            dataSource={soaData?.refundables}
                                                            columns={columns}
                                                            rowKey="id"
                                                            pagination={false}
                                                        /> */}
                                                        <PreviewTable
                                                            dataSource={soaData?.refundables}
                                                            columns={columns}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row gutter={[16, 16]} className='mb-2'>
                                                    <Col span={12}>
                                                    
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className=' amount-total-two' align='right'>
                                                        Total Refundables: {formatAmount(totalRefundable)}
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }
                                    
                                    {
                                        soaData?.open_bills && (
                                            <>
                                                <Row gutter={[16, 16]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                                        Billings
                                                    </Col>
                                                </Row>
                                                <Row gutter={[16, 16]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                                        {/* <Table
                                                            dataSource={soaData?.open_bills}
                                                            columns={columns2}
                                                            rowKey="id"
                                                            pagination={false}
                                                        /> */}
                                                        <PreviewTable
                                                            dataSource={soaData?.open_bills}
                                                            columns={columns2}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row gutter={[16, 16]} className='mb-2'>
                                                    <Col span={12}>
                                                    
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className=' amount-total-two' align='right'>
                                                        Total Billings: {formatAmount(totalBilling)}
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }
                                </>
                            )
                        }
                        <Row gutter={[16, 16]} className='mt-4'>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='' align='end'>
                                <Space className='amount-total'>
                                    <div className=''>
                                        Total Amount Due
                                    </div>
                                    <div className=''>
                                        {formatAmount(remaining)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        {/* <Row gutter={[16, 16]} className='mb-2'>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} align='end'>
                                <Space className='text-print'>
                                    <div>
                                        Payment Due Date
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} align='end'>
                                <Space className='text-print'>
                                    <div>
                                        __________________
                                    </div>
                                </Space>
                            </Col>
                        </Row> */}
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2'>
                                <Row>
                                    <Col className='text-sm'>
                                        Please make checks payable to:
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        Amistad Property Management Services
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        BDO Unibank Account Number: 002420130444
                                    </Col>
                                </Row>
                                <Row className='my-5 text-sm'>
                                    <Col>
                                        Please advise if any payment made is not reflected in this statement.
                                    </Col>
                                </Row>
                                <Row className='my-4'>
                                    <Col align='left text-sm'>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <div>Prepared By,</div>
                                            <img
                                            src={TenantSignature}
                                            alt="Owner Signature"
                                            style={{ height:'10vh', margin: '0' }}
                                            />
                                            <div style={{ borderTop: '1px solid black', width: '150%', marginTop: '0', marginBottom: '0' }}></div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row className='text-sm'>ANA MARIE ANG</Row>
                                        <Row className='text-sm'>Billing and Collection</Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='btn-footer mx-4' align='left'>
                   {
                        type === "move-in" && (
                            <Col span={12}>
                                <Space className='mb-2' >
                                    <Button
                                        onClick={() => navigate('/add-billing/tenant', {state: {rental_unit_id: soaData?.rental_unit_id, property: soaData?.property_id, tradename: soaData?.tenant_id}})}
                                        type='primary'
                                        className='btn-header'
                                    >
                                        Proceed To Billing
                                    </Button>
                                </Space>
                            </Col>
                        )
                   }
                   <Col span={12} align='right'>
                     <Space className='mb-4'>
                        <Button
                            onClick={() => navigate('/tenant')}
                            className='cancel-color btn-header'
                        >
                            Close
                        </Button>
                    
                        <Button
                            onClick={() => handleSendEmail('preview')}
                            className='secondary-btn btn-header'
                            loading={loading}
                        >
                            Send to Email
                        </Button>
                    
                        <Button
                            onClick={handlePrint}
                            type='primary'
                            className='btn-header'
                        >
                            Print
                        </Button>
                    </Space>
                   </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default DebitSOA
